exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-icon:hover .customize[data-v-af593654]{display:block}.carousel-icon .customize[data-v-af593654]{display:none}.carousel-icon[data-v-af593654]  .el-carousel__button{height:3px;width:3px;border-radius:100%;background:#fff}.carousel-icon[data-v-af593654]  .is-active .el-carousel__button{width:10px;border-radius:3px;background-color:var(--portalPrimaryColor)}", ""]);

// exports
